export default "__VITE_ASSET__BcDMQyFo__"